<template>
  <div id="prodData" style="width:100%;height: 100%;padding: 1rem 1rem"></div>
</template>

<script>

import EmCommonApi from "@/mixin/em/common/api";
import * as echarts from 'echarts'; //页面单独引入， 不用全局的了，全局的被屏蔽了

export default {
  name: "echartProdData",
  mixins: [EmCommonApi],
  // props: {
  //   id: String,
  //   echartTitle: String,
  // },
  data() {
    return {
      nodeId: "test_position_2",
      chart: {},

      productData: [[],[]],  // 两个数组是因为有两条线

      option: {},
      fresh: {},
    }
  },
  watch:{
    //监听year的变化，这个year是父组件传递的参数，利用watch监听再刷新当前子组件
    // year(newValue,oldValue){
    //   console.log("旧年份：" + oldValue + "父组件传递的新年份：" + newValue)
    //   this.getRemoteData();
  },
  created() {
    this.getRemoteData()
     // setTimeout(()=>{
     //   this.getRemoteData()
     // },1000)



  },
  mounted() {
    //window.addEventListener('resize', this.chart.resize, false);
    //这里可以屏蔽了，用watch生命周期监控year就可以触发了
    //this.getRemoteData();

    //定时轮巡查询
    this.fresh = setInterval(() => {
      this.getRemoteData();
      window.addEventListener('resize', this.chart.resize, false)
    },  2000);

  },
  beforeDestroy() {
    clearInterval(this.fresh);
    //window.removeEventListener('resize', this.chart.resize, false)
  },
  methods: {
    getRemoteData() {
      /*
      this.$_emApiMixin_get(this.$_emApiMixin_entityBaseApi("emSicEafmREocEmrec") + "/getBdCurrClassProd",)
          .then((res) => {
            console.log("提取鲍店当班产量曲线：")
            console.log(res)
            //console.log(res[0][0])

            //每次循环提取前要清空，否则会累加push
            this.productData[0] = [];
            this.productData[1] = [];

            for(let i in res){
              for(let j in res[i]){
                this.productData[[i]].push(res[i][j].value);
              }
            }

            console.log(this.productData)

            // //如果北车有数据了，再提取南车数据  因为异步调用，会延时
            //     this.$_emApiMixin_post(this.$_emApiMixin_entityBaseApi("emSicEafmREocEmrec") + "/getBdCurrClassProd",
            //         {"end":"","nodeId":"ns=1;s=1.649.1.0.0.0","start":"-1d"})
            //         .then((res_s) => {
            //           console.log("提取鲍店当班产量曲线-南车：")
            //           console.log(res_s.data)
            //           this.productData[1] = [];
            //           for (let key2 in res_s.data) {
            //             this.productData[1].push(res_s.data[key2].value);
            //
            //           }
            //         })
            // console.log(this.productData)

            //记得异步调用后端，要写进then里渲染
            //渲染echart
            this.loadChart()

          })
      */
      //2021.9.26 赵楼调试
      //验收审核临时测试数据
      this.productData[0] = [21.3,44.5,70,140.5,198.6,262.3];
      this.productData[1] = [42.5,68.5,100.61,155.92,210.9,210.9];
      this.loadChart()

    },
    loadChart(){
      this.option = {
        title: {
          text: "当班产量统计",
          textStyle: {
            //文字颜色
            color: '#FFFFFF',
            //字体风格,'normal','italic','oblique'
            fontStyle: 'normal',
            //字体粗细 'normal','bold','bolder','lighter',100 | 200 | 300 | 400...
            fontWeight: 'normal',
            //字体系列
            fontFamily: '微软雅黑',
            //字体大小
            fontSize: 18,
          }
        },
        // 修改两条线的颜色
        color: ['#00f2f1', '#ed3f35'],
        tooltip: {
          trigger: 'axis'
        },
        // 图例组件
        legend: {
          // 当serise 有name值时， legend 不需要写data
          // 修改图例组件文字颜色
          textStyle: {
            color: '#4c9bfd'
          },
          right: '10%',
        },
        grid: {
          top: "20%",
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true,
          show: true, // 显示边框
          borderColor: '#012f4a' // 边框颜色
        },
        xAxis: {
          type: 'category',
          boundaryGap: false, // 去除轴间距
          data: ['1H', '2H', '3H', '4H', '5H', '6H', '7H', '8H', '9H', '10H', '11H', '12H'],   //TODO：2021.8.27考虑采样时间间隔，然后改这里
          // 去除刻度线
          axisTick: {
            show: false
          },
          axisLabel: {
            color: "#4c9bfb" // x轴文本颜色
          },
          axisLine: {
            show: false // 去除轴线
          }
        },
        yAxis: {
          type: 'value',
          // 去除刻度线
          axisTick: {
            show: false
          },
          axisLabel: {
            color: "#4c9bfb" // x轴文本颜色
          },
          axisLine: {
            show: false // 去除轴线
          },
          splitLine: {
            lineStyle: {
              color: "#012f4a"
            }
          }
        },
        series: [{
          type: 'line',
          areaStyle: {},
          smooth: true, // 圆滑的线
          name: '北车',
          data: this.productData[0]
        },
          {
            type: 'line',
            areaStyle: {},
            smooth: true, // 圆滑的线
            name: '南车',
            data: this.productData[1]
          }
        ],

      }
      this.chart = echarts.init(document.getElementById('prodData'),'light');
      this.chart.setOption(this.option)

      //echart浏览器自动缩放
      let myChart = this.chart;
      window.addEventListener('resize',()=>{
        myChart.resize();
      })

    }
  }
}
</script>

<style scoped>

</style>
